import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { IMonthlyOrder, ISelectList } from '../../interfaces';

export function useMonthlyOrder(): IMonthlyOrder {
    return useContext(MobXProviderContext).RootStore.monthlyOrderStore.order;
}
export function useMonthlyOrderAvailableOrders(): ISelectList {
    return useContext(MobXProviderContext).RootStore.monthlyOrderStore.availableOrdersSelect;
}
